import React, { useState, useEffect, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { caApi } from "../../../../../backend_urls/caApi";
import { CAURL } from "../../../../../routes/ca_routes/CAURL";
import DocumentPreview from "../../../../../components/reusable/modals/DocumentPreview";
import InvoiceForm from "../../../../../components/reusable/modals/InvoiceForm";
import LineItemsTable from "../../../../../components/reusable/modals/LineItemsTable";
import InvoiceSummary from "../../../../../components/reusable/modals/InvoiceSummary";
import LoadingSpinner from "../../../../../components/loaders/LoadingSpinner";
import EmptySection from "../../../../../components/EmptySection";
// import ActionButtons from "../../utils/ActionButtons";
import "../../../../../css/pages/ca_pages/CAAllInvoicesPage.css";

const CAClientInvoiceEdit = () => {
    const { invoiceId } = useParams();
    const navigate = useNavigate();

    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [zoom, setZoom] = useState(1);

    const isIGST = data?.invoice?.tax_type === "IGST";
    const isGST = data?.invoice?.tax_type === "CGST_SGST";

    const fetchData = useCallback(async () => {
        try {
            setLoading(true);
            const res = await caApi.retrieveClientInvoice(invoiceId);
            setData(res.data || res);
        } catch (error) {
            console.error("Error fetching invoice:", error);
            navigate(CAURL.CA_ALL_CLIENTS_INVOICES, { replace: true });
        } finally { setLoading(false); }
    }, [invoiceId, navigate]);
    useEffect(() => {
        if (!invoiceId) {
            navigate(CAURL.CA_ALL_CLIENTS_INVOICES, { replace: true });
            return;
        }
        fetchData(invoiceId);
    }, [fetchData, navigate, invoiceId]);

    const handleChange = (field, value) => {
        setData(prev => ({ ...prev, invoice: { ...prev.invoice, [field]: value } }));
    };

    const numericFields = [
        "quantity", "rate", "taxable_value", "cgst_rate", "cgst_amount",
        "sgst_rate", "sgst_amount", "igst_rate", "igst_amount", "line_total"
    ];

    const handleItemChange = (index, field, value) => {
        setData(prev => {
            const updated = [...prev.line_items];
            updated[index] = {
                ...updated[index],
                [field]: numericFields.includes(field)
                    ? Number(value) || 0
                    : value,
            };
            return { ...prev, line_items: updated };
        });
    };

    const addLineItem = () => {
        setData(prev => ({
            ...prev,
            line_items: [
                ...prev.line_items,
                {
                    description: "",
                    quantity: 1,
                    rate: 0,
                    taxable_value: 0,
                    cgst_rate: 0,
                    cgst_amount: 0,
                    sgst_rate: 0,
                    sgst_amount: 0,
                    igst_rate: 0,
                    igst_amount: 0,
                    line_total: 0,
                },
            ],
        }));
    };

    const deleteLineItem = (index) => {
        setData(prev => ({
            ...prev,
            line_items: prev.line_items.filter((_, i) => i !== index),
        }));
    };

    const handleSave = async () => {
        try {
            setLoading(true);
            const payload = {
                ...data.invoice,
                document: data.document?.id,
                line_items: data.line_items.map(item => ({ ...item })),
            };
            await caApi.updateClientInvoice( invoiceId, payload );
            alert("Invoice updated!");
            fetchData(invoiceId);
        } catch (e) { console.error(e);
        } finally { setLoading(false); }
    };

    return ( loading ? <LoadingSpinner /> :
        <div className="invoice-container">
            <div className="invoice-left">
                {
                    data?.document?.file_url ?
                        <DocumentPreview
                            fileUrl = { data?.document?.file_url }
                            zoom    = { zoom }
                            setZoom = { setZoom }
                        />
                    : <EmptySection message="No document attached" />
                }
            </div>

            <div className="invoice-right">
                <InvoiceForm
                    invoice      = { data?.invoice }
                    handleChange = { handleChange }
                    isIGST       = { isIGST }
                    isGST        = { isGST }
                />

                <LineItemsTable
                    items            = { data?.line_items }
                    handleItemChange = { handleItemChange }
                    addLineItem      = { addLineItem }
                    deleteLineItem   = { deleteLineItem }
                    isIGST           = { isIGST }
                    isGST            = { isGST }
                />

                <InvoiceSummary
                    invoice = { data?.invoice }
                    isIGST  = { isIGST }
                    isGST   = { isGST }
                />

                <button onClick={handleSave}>Update</button>
                {/* <br />
                <ActionButtons
                    actions={[
                        {
                            buttonType: "viewOutline",
                            customName: "Update",
                            onClick: () => handleSave,
                        }
                    ]}
                /> */}
            </div>
        </div>
    );
};

export default CAClientInvoiceEdit;
